import type { CityConfig } from "../city-template/types";

export const pierreConfig: CityConfig = {
  city: "Pierre",
  state: "South Dakota",
  stateAbbr: "SD",
  slug: "pierre",
  route: "/pierre",
  title: "Emergency Passport Pierre, SD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Pierre, SD — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Pierre residents, state government professionals, Oahe Dam travelers, and central South Dakota communities.",
  h1: "Emergency & Expedited Passport Services in Pierre, SD",
  heroSubtitle: "State agency business trip to Canada or Europe coming up fast? Legislative exchange program departing next week? Oahe Dam international engineering conference in two weeks? We help Pierre residents — from state government employees and legislators to health care professionals at Avera St. Mary's to Missouri River recreation families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20panoramic%20view%20of%20Pierre%20South%20Dakota%20state%20capitol%20building%20with%20its%20distinctive%20dome%20and%20limestone%20facade%20overlooking%20the%20Missouri%20River%2C%20Oahe%20Dam%20in%20the%20distance%2C%20wide%20prairie%20landscape%20with%20golden%20grasslands%20and%20cottonwood%20trees%20along%20the%20riverbank%2C%20bright%20sunny%20day%20with%20dramatic%20cumulus%20clouds%20over%20the%20Great%20Plains%20sky%2C%20historic%20downtown%20streetscape%20visible%20below%20the%20capitol%20hill&width=1800&height=700&seq=pierre-hero-2026&orientation=landscape",
  heroImageAlt: "South Dakota State Capitol and Missouri River in Pierre South Dakota",
  geoPosition: "44.3683;-100.3510",
  geoPlacename: "Pierre, South Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Located approximately 480 miles east of Pierre via I-90 — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Pierre", zips: "57501" },
    { name: "Fort Pierre", zips: "57532" },
    { name: "Blunt", zips: "57522" },
    { name: "Onida", zips: "57564" },
    { name: "Highmore", zips: "57345" },
    { name: "Gettysburg", zips: "57442" },
    { name: "Murdo", zips: "57559" },
    { name: "Kennebec", zips: "57544" },
    { name: "Chamberlain", zips: "57325" },
    { name: "Miller", zips: "57362" },
    { name: "Eagle Butte", zips: "57625" },
    { name: "Presho", zips: "57568" },
    { name: "Vivian", zips: "57659" },
    { name: "Harrold", zips: "57536" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Minneapolis Passport Agency — as fast as 24 hours for Pierre-area travelers with immediate departures." },
    { icon: "ri-government-line", title: "State Government & Legislative Travel", desc: "Pierre is South Dakota's capital — we serve state legislators, agency directors, and policy staff traveling to international conferences, trade missions, and exchange programs." },
    { icon: "ri-flight-takeoff-line", title: "Pierre Regional Airport Access", desc: "Pierre Regional Airport (PIR) provides daily connections to Denver — a direct gateway to international flights via United. We align processing with PIR schedules." },
    { icon: "ri-anchor-line", title: "Oahe Dam & Missouri River Hub", desc: "Lake Oahe and the Missouri River draw international visitors and support recreation professionals who travel abroad for water management and outdoor industry events." },
  ],
  internalLinks: [
    { name: "Fast passport services in Sioux Falls, SD", route: "/sioux-falls" },
    { name: "Expedited passport in Rapid City, SD", route: "/rapid-city" },
    { name: "Quick passport services in Mitchell, SD", route: "/mitchell" },
    { name: "Urgent passport services in Brookings, SD", route: "/brookings" },
    { name: "South Dakota passport services overview", route: "/south-dakota" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Pierre via secure registered courier with direct access to the Denver Passport Agency at 212 3rd Ave S, Minneapolis. Our registered couriers hand-deliver your documents — meaning you get faster results without the 480-mile drive. Pierre residents can ship from any UPS Store, FedEx Office, or post office location across Hughes County.",
  fpcOfficeDistance: "Serving Pierre, Fort Pierre, Blunt, Onida, Highmore, and all Hughes County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Pierre and Hughes County. From the South Dakota State Capitol and the Governor's Mansion to Avera St. Mary's Hospital, from the Missouri River waterfront to surrounding ranch and farm communities — we serve all of central South Dakota. Our courier service eliminates the need to drive nearly eight hours to the Minneapolis Passport Agency or wait for a post office appointment.",
  nearbyCitiesIntro: "We serve Pierre and surrounding communities including Fort Pierre, Blunt, Onida, Highmore, Gettysburg, and Chamberlain. We also serve travelers departing from Pierre Regional Airport (PIR) who need expedited passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Pierre as simple as possible — with the efficiency and reliability state government professionals, Oahe Dam engineers, and central South Dakota families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Pierre travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Pierre travelers encounter unique passport issues — everything from last-minute legislative exchange program departures to Oahe Dam international conference deadlines to 6-month validity rules for European destinations. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Pierre travelers — from state government professionals to Missouri River families to health care workers — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Pierre, SD? Here are the most common ones we hear from Hughes County travelers.",
  statePageRoute: "/states/south-dakota",
  statePageName: "South Dakota",
  servicesIntro: "Whether you need a renewal before a legislative trade mission to Europe, an emergency passport for a state agency international conference, or a first-time passport for a family vacation abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dps.sd.gov/driver-licensing",
  dmvLabel: "South Dakota DPS Driver Licensing — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "State agency international summit leaving in 3 days? Missouri River water management conference in Canada this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Pierre-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Pierre residents renew fast — no agency visit required for most renewals. Perfect for state government professionals, Avera St. Mary's staff, and Hughes County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Pierre residents through every step — from state government interns to ranch families — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your legislative trip or state conference travel is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family trip abroad or Missouri River heritage tour stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Pierre residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Pierre state officials and business owners who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Pierre-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Pierre SD", description: "Urgent passport processing for Pierre South Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Pierre SD", description: "Fast passport renewal for Pierre South Dakota residents with a previously-issued passport." },
    { name: "First-Time Passport Pierre SD", description: "New passport application services for Pierre South Dakota residents applying for their first passport." },
    { name: "Child Passport Pierre SD", description: "Minor passport services for Pierre South Dakota families with children under 16." },
    { name: "Name Change Passport Pierre SD", description: "Passport name correction after marriage, divorce, or legal name changes for Pierre residents." },
    { name: "Second Passport Pierre SD", description: "Second passport services for Pierre state officials and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Jim D.",
      location: "State Agency Director, Pierre",
      rating: 5,
      text: "Got called to attend an international water management summit in the Netherlands with 10 days notice. My passport was expired. Fast Passport Center got it done in 6 days. I made every session.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Nancy K.",
      location: "Legislative Aide, Pierre",
      rating: 5,
      text: "Our delegation had a trade mission to Germany and my passport was expiring during session. They handled the renewal while I was on the floor every day. Zero stress.",
      service: "Passport Renewal",
    },
    {
      name: "The Bauer Family",
      location: "Hughes County",
      rating: 5,
      text: "We planned a family trip tracing our German heritage across Europe. Three of us needed renewals and our youngest needed a first passport. Fast Passport Center managed all four applications and everything arrived on time.",
      service: "Family Passports",
    },
    {
      name: "Dr. Mark S.",
      location: "Avera St. Mary's, Pierre",
      rating: 5,
      text: "I had a medical conference presentation in Switzerland. My passport expired during a busy rotation and I did not notice until 2 weeks before departure. They came through — I presented on time.",
      service: "Emergency Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "pierre-1",
      name: "Pierre Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "225 S Pierre St",
      city: "Pierre",
      state: "SD",
      zip: "57501",
      phone: "(605) 224-7151",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Pierre",
      website: "https://tools.usps.com/find-location.htm?location=1368579",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility serving Pierre and Hughes County. Passport photos available. Appointment strongly recommended — limited walk-in capacity especially during legislative session.",
      icon: "ri-mail-line",
    },
    {
      id: "pierre-2",
      name: "Hughes County Clerk of Courts",
      type: "County Clerk Passport Acceptance",
      address: "104 E Capitol Ave",
      city: "Pierre",
      state: "SD",
      zip: "57501",
      phone: "(605) 773-3713",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Hughes County Courthouse",
      website: "https://www.hughescounty.org/",
      websiteLabel: "Hughes County",
      notes: "County clerk office offering passport acceptance services. Convenient for state capitol complex employees. Call ahead to confirm clerk availability during legislative session.",
      icon: "ri-government-line",
    },
    {
      id: "pierre-3",
      name: "Fort Pierre Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "317 N 1st St",
      city: "Fort Pierre",
      state: "SD",
      zip: "57532",
      phone: "(605) 223-2332",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Fort Pierre — 2 miles west across the Missouri River",
      website: "https://tools.usps.com/find-location.htm?location=1368576",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility across the river in Fort Pierre. Passport photos available. Convenient for Stanley County residents. Call ahead to confirm hours.",
      icon: "ri-mail-line",
    },
    {
      id: "pierre-4",
      name: "Chamberlain Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "103 N Sanborn St",
      city: "Chamberlain",
      state: "SD",
      zip: "57325",
      phone: "(605) 234-6661",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Chamberlain — 68 miles south on US-83",
      website: "https://tools.usps.com/find-location.htm?location=1368567",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for southern Hughes County and Brule County residents. Limited hours — call ahead to confirm availability.",
      icon: "ri-mail-line",
    },
    {
      id: "pierre-5",
      name: "Aberdeen Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1202 S 5th St",
      city: "Aberdeen",
      state: "SD",
      zip: "57401",
      phone: "(605) 226-2188",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Aberdeen — 150 miles northeast via US-281",
      website: "https://tools.usps.com/find-location.htm?location=1368591",
      websiteLabel: "USPS Location",
      notes: "Larger acceptance facility with more appointment availability. Full photo services. Worth the drive for guaranteed service if Pierre facilities are booked.",
      icon: "ri-mail-line",
    },
    {
      id: "pierre-6",
      name: "Sioux Falls Downtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 S 2nd Ave",
      city: "Sioux Falls",
      state: "SD",
      zip: "57104",
      phone: "(605) 336-3343",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Sioux Falls — 210 miles east via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1368468",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in South Dakota. Full photo services and most appointment availability. Consider combining with a Pierre-to-Sioux Falls business trip.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 480 miles to Denver Passport Agency", fpc: "Most Pierre travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "SD-Specific Guidance", agency: "Generic — no capital city, state government, or central SD expertise", fpc: "Full state government/Lake Oahe/central SD knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "State Government Rush Periods",
      description: "Pierre's legislative session (January–March) creates periods when state employees and officials are busier than ever — and passport renewals fall through the cracks. We recommend checking validity during the off-season months.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Pierre applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Pierre pharmacy and retail store photos fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Hughes County families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "PIR Flight Connection Timing",
      description: "Pierre Regional Airport connects through Denver, and travelers sometimes book international connections assuming their passport processing will align with domestic-only schedules. We help plan realistic timelines.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or the capitol complex." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Pierre clients ship from home or the UPS Store on Sioux Avenue — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 480 miles to Minneapolis or wait at a rural post office." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Pierre?", a: "We offer Pierre-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Pierre?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Pierre post office or Hughes County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Pierre address." },
    { q: "Where can I get passport acceptance in Pierre?", a: "Pierre has passport acceptance at the Main Post Office (225 S Pierre St) and the Hughes County Clerk of Courts (104 E Capitol Ave). Nearby options include post offices in Fort Pierre and Chamberlain." },
    { q: "Can I fly internationally from Pierre Regional Airport?", a: "Pierre Regional Airport (PIR) offers daily United flights to Denver International Airport (DEN), a major international gateway. Travelers can connect through DEN to destinations worldwide. We can coordinate passport processing timelines with your PIR departure." },
    { q: "Can state government employees get expedited passports?", a: "Yes. Many Pierre state employees, legislators, and agency staff travel internationally for conferences, trade missions, and exchange programs. Our expedited courier service accommodates government travel deadlines, including last-minute legislative delegations." },
    { q: "What documents do Pierre applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Pierre-specific checklist." },
    { q: "Can I get a passport photo in Pierre?", a: "Yes — the Pierre Main Post Office offers passport photos on-site. Additional photo locations include Lewis Drug, Walmart, and Walgreens. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How far is the nearest passport agency from Pierre?", a: "The Minneapolis Passport Agency (212 3rd Ave S, Minneapolis, MN) is approximately 480 miles east of Pierre via I-90. It requires appointments for life-or-death emergencies only. For travel within 3–14 days, our registered courier service is the fastest legally available channel." },
    { q: "How do I check my Pierre passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Pierre to final return shipping typically matches your chosen speed tier." },
    { q: "Does legislative session affect passport processing times in Pierre?", a: "Legislative session (January–March) does not affect State Department processing directly, but it creates a period when many state employees and officials are too busy to address passport renewals. We recommend checking passport validity outside of session when schedules are more manageable." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Pierre Residents",
    intro: "Pierre's role as South Dakota's state capital and Missouri River recreation hub creates unique passport timing challenges. Here's what Pierre travelers need to know.",
    cards: [
      {
        icon: "ri-government-line",
        title: "State Government & Legislative Travel",
        subtitle: "Trade missions, international conferences, and exchange programs",
        description: "As South Dakota's capital city, Pierre is home to the Governor's Office, Legislature, and dozens of state agencies. International travel for trade missions to Europe and Asia, water management conferences in Canada, and legislative exchange programs create steady passport demand. The challenge: government travel often materializes with short notice — sometimes 2–3 weeks before departure.",
        tip: "State employees should check passport validity at the start of each fiscal year (July). Keep your passport current — international travel assignments can appear with minimal lead time.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Pierre Regional Airport (PIR) — Your International Gateway",
        subtitle: "Daily Denver connections open the world",
        description: "Pierre Regional Airport (PIR) offers daily United Express flights to Denver International Airport (DEN), providing Pierre residents with one-stop access to Asia, Europe, and the Americas. The key consideration: PIR flights are limited to a few daily departures, so international connection timing matters. Your passport must be valid at least 6 months beyond your return date for most international destinations.",
        tip: "Book PIR flights with at least 3 hours connection time in Denver for international departures. And always check passport validity before booking — not after.",
      },
      {
        icon: "ri-anchor-line",
        title: "Lake Oahe & Missouri River Recreation",
        subtitle: "Water management, outdoor recreation, and international tourism",
        description: "Lake Oahe — one of the largest reservoirs in the U.S. — draws international visitors for fishing tournaments, water sports, and outdoor recreation. Many Pierre-based recreation professionals and guides attend international outdoor industry shows in Canada and Europe. Water management professionals from the Oahe Dam participate in international dam and reservoir conferences worldwide.",
        tip: "Off-season (October–March) is the best time for recreation professionals to renew passports — before the busy summer season creates scheduling conflicts.",
      },
      {
        icon: "ri-hospital-line",
        title: "Avera St. Mary's & Health Care Travel",
        subtitle: "Medical conferences, research collaborations, and mission trips",
        description: "Avera St. Mary's Hospital serves as central South Dakota's primary health care hub. Medical professionals travel internationally for conferences, research collaborations, and occasional mission trips to Central America and Africa. Conference presentations often require travel on very specific dates with no flexibility — making expedited passport processing essential for last-minute schedule changes.",
        tip: "Health care professionals presenting at international conferences should have passport contingencies ready. Conference acceptance can come with as little as 4–6 weeks notice.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Pierre & Central South Dakota Travel Patterns",
      description: "Pierre's centralized location serves as the hub for a vast rural area spanning Hughes, Stanley, Sully, and surrounding counties. Many travelers from smaller communities come through Pierre for passport services, creating steady demand throughout the year.",
    },
  },
  destinations: {
    title: "Where Pierre Travelers Go — And Why Passports Get Urgent",
    intro: "Pierre's mix of state government, Missouri River recreation, and central South Dakota agriculture creates diverse passport needs. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "40%", label: "of Pierre expedited requests are state government or legislative travel-related" },
      { stat: "2–4 Weeks", label: "average lead time for state officials receiving international conference invitations" },
      { stat: "Jan–Mar", label: "peak period when legislative session makes passport renewals hard to schedule" },
      { stat: "480 Miles", label: "distance Pierre residents avoid by using our courier instead of driving to the Minneapolis agency" },
    ],
    destinations: [
      { name: "Germany", context: "State trade missions, water management conferences, legislative exchange programs", urgency: "Conference dates fixed — 2–4 week notice common", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Water management, agriculture trade, outdoor recreation industry shows", urgency: "Summer conference season May–August, passport card popular", icon: "ri-map-pin-2-line" },
      { name: "Netherlands & Denmark", context: "Water management and dam engineering conferences, agricultural technology exchanges", urgency: "Fixed conference dates — 3–8 week planning typical", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "State agriculture trade missions, technology exchange programs", urgency: "Long-lead planning but last-minute delegation changes common", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "Winter getaways from South Dakota cold, Avera mission trips, agricultural exchanges", urgency: "Last-minute resort deals 3–4 weeks out during January–March", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "Legislative exchange programs, heritage travel, agricultural best practices tours", urgency: "Parliamentary exchanges booked 2–3 months in advance", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other South Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Mount Rushmore State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Sioux Falls", route: "/sioux-falls" },
      { name: "Rapid City", route: "/rapid-city" },
      { name: "Aberdeen", route: "/aberdeen-sd" },
    ],
  },
  photoLocations: [
    { name: "Pierre Main Post Office", address: "225 S Pierre St, Pierre, SD 57501", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Lewis Drug — Pierre", address: "425 S Pierre St, Pierre, SD 57501", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 9 AM – 6 PM" },
    { name: "Walmart Supercenter — Pierre", address: "1730 N Garfield Ave, Pierre, SD 57501", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — Pierre", address: "625 Broadway Ave, Pierre, SD 57501", hours: "Daily 8 AM – 10 PM" },
    { name: "UPS Store — Pierre", address: "220 S Pierre St, Pierre, SD 57501", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM" },
    { name: "Fort Pierre Post Office", address: "317 N 1st St, Fort Pierre, SD 57532", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Chamberlain Post Office", address: "103 N Sanborn St, Chamberlain, SD 57325", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "FedEx Office — Sioux Falls", address: "3400 W 49th St, Sioux Falls, SD 57106", hours: "Mon–Fri 7:30 AM – 9 PM, Sat 9 AM – 6 PM" },
  ],
  dmvLocations: [
    {
      name: "Pierre DPS Driver License Exam Station",
      address: "1301 E Sioux Ave, Pierre, SD 57501",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Driver licenses, REAL ID, written and road tests. Appointment recommended.",
      featured: true,
    },
    {
      name: "Sioux Falls DPS Driver License Exam Station",
      address: "3101 W Russell St, Sioux Falls, SD 57107",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Full-service DPS driver license office serving Minnehaha County. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PIR",
      name: "Pierre Regional Airport",
      distance: "About 4 miles east of downtown Pierre via US-14",
      address: "3800 Airport Rd, Pierre, SD 57501",
      note: "Pierre's local airport with daily United Express flights to Denver International Airport (DEN). DEN is a major international gateway with connections worldwide. Free long-term parking available.",
      flightUrl: "https://www.pierreairport.com/",
      flightLabel: "PIR Airport Website",
      featured: true,
    },
    {
      code: "FSD",
      name: "Sioux Falls Regional Airport (Joe Foss Field)",
      distance: "About 210 miles east of Pierre via I-90",
      address: "2801 N Jaycee Ln, Sioux Falls, SD 57104",
      note: "Largest airport in South Dakota with daily nonstop connections to MSP, ORD, DEN, and DFW — all major international gateways. About a 3.5-hour drive from Pierre.",
      flightUrl: "https://www.sfairport.com/",
      flightLabel: "FSD Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the South Dakota Department of Health Vital Records. Online, mail, or in-person options available.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through SD Department of Health Vital Records. Required for estate and legal matters.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Hughes County Register of Deeds. Certified copies available for name changes and legal purposes.",
      url: "https://www.hughescounty.org/departments/register-of-deeds",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Hughes County Clerk of Courts. Required for name change passport corrections.",
      url: "https://www.hughescounty.org/departments/clerk-of-courts",
    },
  ],
};